import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from './js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from './js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CharSequenceClass;
function CharSequence() {
  if (CharSequenceClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'CharSequence');
    CharSequenceClass = $;
  }
  return CharSequenceClass;
}
//region block: exports
export {
  CharSequence as CharSequence1ceii1xorfwh7,
};
//endregion

//# sourceMappingURL=CharSequence.mjs.map
